import { TabsUnstyled } from '@mui/base'
import { styled } from '@mui/material'
import useGetTabsTemplate from '~/src/components/mui-wrappers/styled/delivery-methods/tabs/styles/useGetTabsTemplate'

const DeliveryMethodsTabs = styled(TabsUnstyled)(() => useGetTabsTemplate().getComponentSx())

export default DeliveryMethodsTabs
